<!-- ========== PAGE HERO ========== -->
<section class="ds-page-hero">
  <div class="ds-orb ds-orb--soft ds-page-hero__orb-1"></div>
  <div class="ds-orb ds-orb--cobalt ds-page-hero__orb-2"></div>
  <div class="container ds-page-hero__inner">
    <span class="ds-pill">Müşteri Hikayeleri</span>
    <h1>Başarı Hikayeleri</h1>
    <p class="ds-lead">Keyo AI kullanan e-ticaret sitelerinin gerçek deneyimleri ve elde ettikleri sonuçlar.</p>
  </div>
</section>

<section class="ds-section ds-customers">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-6">
        <div class="ds-testimonial">
          <div class="ds-testimonial__head">
            <div class="ds-testimonial__avatar">
              <img src="assets/images/testimonial1.svg" alt="Suna Bayutku - Turkuaz Sağlık">
            </div>
            <div>
              <h5>Suna Bayutku</h5>
              <p>Turkuaz Sağlık</p>
            </div>
          </div>
          <div class="ds-testimonial__quote">
            <p>Keyo AI entegrasyonundan sonra müşteri memnuniyetimiz %35 arttı, sepet terk oranımız ise %22 azaldı. Müşterilerimiz 7/24 destek alabilmekten çok memnun.</p>
            <p>Özellikle sesli asistan özelliği, mobil kullanıcılarımız tarafından çok beğenildi. Ürün arama ve sipariş takibi süreçleri çok daha hızlı ve kolay hale geldi.</p>
          </div>
          <div class="ds-testimonial__stats">
            <div>
              <h4>%35</h4>
              <p>Müşteri Memnuniyeti Artışı</p>
            </div>
            <div>
              <h4>%22</h4>
              <p>Sepet Terk Oranı Azalışı</p>
            </div>
            <div>
              <h4>2.5x</h4>
              <p>Dönüşüm Artışı</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="ds-testimonial">
          <div class="ds-testimonial__head">
            <div class="ds-testimonial__avatar">
              <img src="assets/images/testimonial2.svg" alt="Görkem Korkmaz - Medipera Medikal">
            </div>
            <div>
              <h5>Görkem Korkmaz</h5>
              <p>Medipera Medikal</p>
            </div>
          </div>
          <div class="ds-testimonial__quote">
            <p>Teknik entegrasyon süreci çok hızlı ve sorunsuz geçti. Yapay zeka asistanı müşterilerimizin sorularını büyük bir doğrulukla yanıtlıyor.</p>
            <p>API entegrasyonu ve özelleştirme seçenekleri sayesinde mevcut sistemlerimizle mükemmel uyum sağladı. Teknik destek ekibi her zaman yardımcı oldu.</p>
          </div>
          <div class="ds-testimonial__stats">
            <div>
              <h4>%95</h4>
              <p>Doğru Yanıt Oranı</p>
            </div>
            <div>
              <h4>3s</h4>
              <p>Ortalama Yanıt Süresi</p>
            </div>
            <div>
              <h4>%40</h4>
              <p>Destek Maliyeti Azalışı</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>

<!-- ========== FINAL CTA ========== -->
<section class="ds-final-cta">
  <div class="container">
    <div class="ds-final-cta__panel">
      <div class="ds-orb ds-orb--soft ds-final-cta__orb"></div>
      <div class="ds-final-cta__content">
        <h2>Siz de Başarı Hikayenizi Yazın</h2>
        <p class="ds-lead">Demo talep edin, sizinle de aynı sonuçları alalım.</p>
        <a routerLink="/contact" fragment="contact-form" class="btn btn-light btn-lg mt-3">Demo Talep Et</a>
      </div>
    </div>
  </div>
</section>
